/** Returns true if script uses a custom product
    @param script Script to check within.
 */
function isCustom(script) {
  return Boolean(script && script.meta && script.meta.products && script.meta.products.length
      && script.meta.products[0].isCustom);
}

export default isCustom;